import { render, staticRenderFns } from "./BuildSituation.vue?vue&type=template&id=29035fbf&scoped=true&"
import script from "./BuildSituation.vue?vue&type=script&lang=js&"
export * from "./BuildSituation.vue?vue&type=script&lang=js&"
import style0 from "./BuildSituation.vue?vue&type=style&index=0&id=29035fbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29035fbf",
  null
  
)

export default component.exports